/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs */

const en_admin_resources_resource_allocations_cancellation_period = /** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation Period`)
};

const de_admin_resources_resource_allocations_cancellation_period = /** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigungsfrist`)
};

const es_admin_resources_resource_allocations_cancellation_period = /** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período de cancelación`)
};

const fr_admin_resources_resource_allocations_cancellation_period = /** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période de préavis`)
};

const nl_admin_resources_resource_allocations_cancellation_period = /** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzegtermijn`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_cancellation_period = en_admin_resources_resource_allocations_cancellation_period;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_cancellation_period = en_admin_resources_resource_allocations_cancellation_period;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_cancellation_period = en_admin_resources_resource_allocations_cancellation_period;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_cancellation_period = en_admin_resources_resource_allocations_cancellation_period;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_cancellation_period = en_admin_resources_resource_allocations_cancellation_period;

/**
* | output |
* | --- |
* | "Cancellation Period" |
*
* @param {Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_cancellation_period = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Cancellation_PeriodInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_cancellation_period(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_cancellation_period(inputs)
	return ro_admin_resources_resource_allocations_cancellation_period(inputs)
});
export { admin_resources_resource_allocations_cancellation_period as "admin.resources.resource_allocations.cancellation_period" }